<div class="space-y-4" aria-hidden="true">
	<div class="grid grid-cols-2 sm:grid-cols-4 gap-3">
		@for (k of kpis; track $index) {
		<div class="bg-surface p-3 rounded-2xl border border-line animate-pulse">
			<div class="h-3 w-16 bg-surface-gray rounded-full"></div>
			<div class="h-5 w-12 bg-surface-gray rounded-full mt-3"></div>
			<div class="h-2.5 w-20 bg-surface-gray rounded-full mt-2"></div>
		</div>
		}
	</div>
	<div class="grid grid-cols-1 lg:grid-cols-2 gap-4">
		@for (c of charts; track $index) {
		<div class="bg-surface p-4 rounded-2xl border border-line animate-pulse h-[280px] flex flex-col gap-3">
			<div class="h-4 w-32 bg-surface-gray rounded-full"></div>
			<div class="flex-1 bg-surface-gray rounded-xl"></div>
		</div>
		}
	</div>
</div>
